import React from 'react';
import { timezonesDataSource } from 'infrastructure/data-sources/timezones';

import s from './styles.module.scss';

interface IProps {
  timezone?: string;
}

function extractGMTOffset(value: string): string | null {
  const match = value.match(/\(?([+-]\d{2}:\d{2})\)?/);
  return match ? match[1] : null;
}

const TimezoneCol: React.FC<IProps> = ({ timezone }) => {
  const timezoneRec = timezonesDataSource().find((el) => el.id === timezone);

  if (!timezoneRec) return '-';

  return (
    <span className={s.text}>{extractGMTOffset(timezoneRec.name)} GMT</span>
  );
};

export default TimezoneCol;
